module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-4-ac13afe383df0c8c6a5e75b0675f7d80.jpg";